import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateGmailIntegrationName = {
  name: "updateGmailIntegrationName" as const,
  input: z.object({
    integrationId: zExt.objectId(),
    name: z.string().min(1, "Name is required").max(100, "Name too long"),
  }),
  output: z.object({ success: z.boolean() }),
};
